export const environment = {
    production: false,
    identityUrl: 'https://identity-v2-staging.nside.io',
    withCredentials: true,
    angularAppUrl: 'https://assess-v2-staging.nside.io',
    apiBaseUrl: 'https://assess-api-staging.nside.io',
    tipsApiBaseUrl: 'https://tips-v2-staging.nside.io'
};
